import React, {
  FC,
  Dispatch,
  SetStateAction,
  memo,
  useEffect,
  useMemo,
  useRef,
  RefObject,
  useCallback,
} from "react";
import dayjs from "dayjs";
import "dayjs/plugin/weekOfYear";
import cn from "classnames";
import style from "./index.module.less";
import DfSinglePrice from "@df-mobile/df-single-price";
interface IProps {
  date: string;
  active: string;
  containerDom: RefObject<HTMLDivElement>;
  ulDom: RefObject<HTMLUListElement>;
  disabled: boolean;
  icon?: string;
  price: number | string | undefined;
  setActive: Dispatch<SetStateAction<string>>;
  label: string;
}

// const weekOfYear = require('dayjs/plugin/weekOfYear')

// dayjs.extend(weekOfYear)

export enum DayEnum {
  "周日" = 0,
  "周一" = 1,
  "周二" = 2,
  "周三" = 3,
  "周四" = 4,
  "周五" = 5,
  "周六" = 6,
}

export const formateDate = (date: string) => {
  if (dayjs(date).format("YYYY-MM-DD") == dayjs().format("YYYY-MM-DD")) {
    return "今天";
  }
  if (dayjs(date).diff(dayjs().format("YYYY-MM-DD"), "day") === 1) {
    return "明天";
  }
  if (dayjs(date).diff(dayjs().format("YYYY-MM-DD"), "day") === 2) {
    return "后天";
  }
  // if (dayjs(date).subtract(1, 'day').week() === dayjs().subtract(1, 'day').week()) {
  //   return `本${DayEnum[dayjs(date).day()]}`
  // }
  // if ((dayjs(date).subtract(1, 'day').week() - dayjs().subtract(1, 'day').week()) === 1) {
  //   return `下${DayEnum[dayjs(date).day()]}`
  // }
  return DayEnum[dayjs(date).day()];
};

const CalendarItem: FC<IProps> = (props) => {
  const dom = useRef<HTMLLIElement>(null);
  const {
    active,
    setActive,
    containerDom,
    ulDom,
    date,
    icon,
    disabled = false,
    price,
    label
  } = props;
  useEffect(() => {
    if (active === date && containerDom && ulDom) {
      const half =
        Number(containerDom.current?.clientWidth) / 2 -
        Number(dom.current?.clientWidth) / 2;
      if (containerDom.current) {
        if (Number(dom.current?.offsetLeft) >= half) {
          containerDom.current.scrollLeft =
            Number(dom.current?.offsetLeft) - half;
        } else {
          containerDom.current.scrollLeft =
            Number(dom.current?.offsetLeft) - half;
        }
      }
    }
  }, [date, active]);

  const handleClick = useCallback(() => {
    if (disabled) return;
    setActive(date);
  }, [date, disabled]);

  return useMemo(() => {
    const d = dayjs(date);
    return (
      <li
        ref={dom}
        className={cn(
          active === date && style.active,
          style.item,
          disabled && style.disabled
        )}
        onClick={handleClick}
      >
        {/* <span>{formateDate(date)}</span> */}
        <span className={style.labelZw}>{label}</span>
        <span>{d.format("MM-DD")}</span>
        {!disabled && (
          <div className={style.marT4}>
            <DfSinglePrice price={Number(price) || undefined} priceSize="XL14" icon={icon}  />
          </div>
        )}
        {disabled && <span className={style.marT4}>不可订</span>}
      </li>
    );
  }, [active, date, disabled, price]);
};

export default memo(CalendarItem);
